<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chtitle">Contents</h2>
<p class="noindent"><a href="#/xhtml/00_Cover">Cover</a></p>
<p class="noindent"><a href="#/xhtml/02_Title">Title Page</a></p>
<p class="noindent"><a href="#/xhtml/06_Chapter01">Marseille</a></p>
<p class="noindent"><a href="#/xhtml/07_Chapter02">Lebanon</a></p>
<p class="noindent"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Syria</span></p>
<p class="noindent"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Turkey</span></p>
<p class="noindent"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Malta</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Tunisia</span></p>
<p class="noindent"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">Libya</span></p>
<p class="noindent"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample">Greece</span></p>
<p class="noindent"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample">Crete</span></p>
<p class="noindent"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample">Israel</span></p>
<p class="noindent"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample">Back at the Farm</span></p>
<p class="noindent"><span href="#/xhtml/05_Acknowledgements" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="noindent"><span href="#/xhtml/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?04af48ac